module.exports = __webpack_public_path__ + "media/bootstrap-icons/download-e59d328a.svg";